/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const dailyActivity = useStore((state) => state.dailyActivity);
  const setDailyActivity = useStore((state) => state.setDailyActivity);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.dailyActivity.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={dailyActivity}
          onChange={(value) => {
            setDailyActivity(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'daily-activity',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'deskJob'}>
            <span>💻</span> {t('onboarding.dailyActivity.options.deskJob')}
          </Option>
          <Option value={'moving'}>
            <span>🏃</span> {t('onboarding.dailyActivity.options.moving')}
          </Option>
          <Option value={'workingOut'}>
            <span>🏋️</span> {t('onboarding.dailyActivity.options.workingOut')}
          </Option>
          <Option value={'atHome'}>
            <span>🏠</span> {t('onboarding.dailyActivity.options.atHome')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
